import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative bg-[#F5F5F7] text-[#0B0C10] py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
      <Reveal className="lg:col-span-4">
        <Eyebrow light>FAQ</Eyebrow>
        <h2 className="mt-5 font-display font-black text-4xl sm:text-5xl tracking-[-0.03em] leading-[0.95]">Straight answers.</h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible defaultValue="item-0" className="bg-white rounded-[6px] border border-zinc-200 px-5 sm:px-8">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-zinc-200 last:border-b-0">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg sm:text-xl font-semibold hover:no-underline hover:text-[#C2410C] [&>svg]:text-[#FF6B00]">
                <span className="flex gap-4">
                  <span className="font-mono text-xs text-[#C2410C] pt-1.5">0{i + 1}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="pl-9 pb-6 text-base text-zinc-700 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
